export default "__VITE_ASSET__DMLExJH7__"